module.exports = __webpack_public_path__ + "img/2.6bdae4f2.jpg";